// canvasLoop.js

export default class CanvasLoop {
  constructor(canvas, options) {
    this.canvas = canvas;
    this.update = options.update;
    this.draw = options.draw;

    this.BUBBLE_RADIUS = options.BUBBLE_RADIUS;
    this.GRID_COLS = options.GRID_COLS;
    this.ROW_HEIGHT = options.ROW_HEIGHT;
    this.GRID_ROWS = options.GRID_ROWS;

    this.lastTime = 0;
    this.animFrame = null;
  }

  initCanvas() {
    if (!this.canvas) return;

    const dpr = window.devicePixelRatio || 1;
    const logicalWidth =
      this.BUBBLE_RADIUS * 2 * this.GRID_COLS + this.BUBBLE_RADIUS;
    const logicalHeight =
      this.ROW_HEIGHT * this.GRID_ROWS + 50;

    this.canvas.width = logicalWidth * dpr;
    this.canvas.height = logicalHeight * dpr;
    this.canvas.style.width = logicalWidth + "px";
    this.canvas.style.height = logicalHeight + "px";
  }

  start() {
    this.initCanvas();
    this.lastTime = performance.now();

    const loop = (time) => {
      const dt = time - this.lastTime;
      this.lastTime = time;

      this.update(dt);
      this.draw();

      this.animFrame = requestAnimationFrame(loop);
    };

    this.animFrame = requestAnimationFrame(loop);
  }

  stop() {
    if (this.animFrame) cancelAnimationFrame(this.animFrame);
  }
}